import { trimStart } from "../../utils/strings"

export const absoluteUrl = (relativePath?: string) =>
  `${process.env.SITE_URL ?? "https://www.modusprofumerie.it"}/${trimStart(
    relativePath ?? "",
    "/"
  )}`
